var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      maxWidth: "1000",
      width: "70%",
      scrollable: "",
      height: "600",
      title: _vm.$t("label_essweb_leaveType_form_dialog_editHolidayTypeTitle"),
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                defaultSelect: _vm.PorpertyData,
                items: _vm.desserts,
                itemKey: "uuid",
                showSelect: _vm.showSelect,
              },
              on: {
                select: function (sel) {
                  return (_vm.selected = sel)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.holiday_type_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(_vm.$getCommonLangValue(item.holiday_type_name))
                      ),
                    ]
                  },
                },
                {
                  key: "item.holiday_type_code",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(_vm._s(item.holiday_type_code))]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.editPorperty, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }